import React from 'react';

class Overlay extends React.Component {

  constructor( props ){
    super( props );
    this.state = {
      show: this.props.show === undefined ? false : this.props.show,
      styles: this.props.style,
      hasError: false,
      error: {},
      info: {}
    };
    this.onClickOverlay = this.onClickOverlay.bind( this );
  }

  componentDidCatch( error, info ) {
    this.setState( {
      hasError: true,
      error: error,
      info: info
    } );
  }

  componentWillReceiveProps( nextProps ){
    this.setState( {
      show: nextProps.show === undefined ? false : nextProps.show,
      styles: this.props.style,
    } );
  }

  onClickOverlay( e ) {
    if( this.props.onClickOverlay !== undefined ) {
      this.props.onClickOverlay( e );
    }
  }

  render() {
    if( this.state.hasError === false ) {
      if( this.state.show === true ){
        return (
          <div className='overlay' style={this.state.styles} onClick={this.onClickOverlay} ></div>
        );
      } else {
        return (
          <div className='overlay-hidden'></div>
        );
      }
    } else {
      return ( <span></span> );
    }
  }
}

export default Overlay;



// WEBPACK FOOTER //
// ./src/presentation/Overlay.js